import { genderOptions } from "src/constants/common";
import { SupportProgramType } from "src/types/supportProgram.types";

export default {
  psp_name: "Anaya",
  logo_url:
    "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-logo.svg",
  medical_condition_group_id: {
    uat: "0c01eae6-624a-11ec-9077-ab9c0a5eb881",
    prod: "0c01eae6-624a-11ec-9077-ab9c0a5eb881",
  },
  support_program_name: "Anaya Care Program",
  support_program_key: "anaya-care-program",
  program_type: "cycle", // ["cycle", "timeline"]
  loggers: [],
  theme: {
    colors: {
      primary: "#50B55D",
      secondary: "#592584",
      primaryHover: "#3D9149",
      secondaryHover: "#451B69",
      primaryBackground: "#F0F0F0",
      secondaryBackground: "#F0F0F0",
      background: "#ffffff",
      foreground: "#ffffff",
      shimmerBackground: "#e2e8f0",
      border: "#e2e8f0",
    },
    fonts: {
      primary: "Roboto",
      secondary: "Open Sans",
      tertiary: "Montserrat",
    },
  },
  config: {
    enableWallet: true,
    enableDrugDelivery: true,
    enableDrugClaimJourney: true,
  },
  documents: {
    document_type: "onco_cycle_report",
    required_documents: [
      {
        id: "prescription",
        title: "Doctor's Prescription",
        description:
          "Upload your doctor's prescription which mentions the cancer medication",
        required: true,
        supported_file_types: ["pdf", "jpg", "png"],
        max_file_size_in_mb: 10, // 10MB
        document_type: "Prescriptions",
      },
      {
        id: "invoice",
        title: "Purchase Invoice",
        description:
          "Upload your purchase invoice which mentions the medication for which you are availing the program",
        required: false,
        supported_file_types: ["pdf", "jpg", "png"],
        max_file_size_in_mb: 10, // 10MB
        document_type: "Invoice",
      },
    ],
  },
  website: {
    hero_image:
      "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-care/hero-content.d129050852b2c7c84329.webp",
    benefits: {
      title: "Get Anaya Care Program for free with every purchase",
      subtitle: "Program Offerings",
      benefits: [
        {
          title: "Dedicated Care Specialist",
          description:
            "Stay connected with your dedicated guide for constant care and support throughout your treatment journey",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-care/care-specialist.13ba49745298e1ecd2b4.webp",
        },
        {
          title: "Free Consultation with Nutritionist",
          description:
            "Ongoing personalised guidance from a nutritionist to support your health goals.",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-care/coach-consultations-v2.10990432b6554a54a649.png",
        },
        {
          title: "Free Drug Support",
          description:
            "On the purchase of prescribed medications, you may be eligible to receive additional medications free of cost.",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-care/free-drug-support.8ab9b240914c7d3ecf73.webp",
        },
        {
          title: "Educational Content",
          description:
            "Explore comprehensive educational resources on the app and understand your condition better.",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-care/health-record-management.bfe070dbcd62e4eaef2d.webp",
        },
        {
          title: "Health Records Management",
          description:
            "Securely store and access all your medical records easily, retrieve them whenever you need.",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-care/curated-educational-content.333ebe6a695001653db7.webp",
        },
      ],
    },
    faqs: {
      title: "FAQ's",
      faqs: [
        {
          question: "Who should download this app?",
          answer:
            "Between a patient and a caregiver, we highly recommend that the patient downloads this app.",
        },
        {
          question: "Is there an additional fee for this support program?",
          answer:
            "No, this is a free support program as part of your Cancer Drug. There are however certain services within the support program which follow a pay as you go model - for eg., buying care products, booking a test, etc.",
        },
        {
          question: "How secure is my data?",
          answer:
            "All data is secure and stored in encrypted servers. Other than data that is willingly shared for the purposes of availing the service, no other data of the patient is accessed.",
        },
        {
          question: "Who is eligible for this support program?",
          answer:
            "All patients who have been prescribed and have purchased Sigrima (for breast cancer) or Nivolumab (for other cancer types) are eligible for this program.",
        },
      ],
    },
    request_call_section: {
      title: "Request a call",
      description:
        "We're here to help you get started. Request a call and we'll get back to you as soon as possible.",
    },
  },
  onboarding: {
    steps: [
      {
        id: "mobile_number_capture",
        title: "Enter your mobile number",
        description: "We'll send a verification code to your mobile number",
        type: "mobile_number",
      },
      {
        id: "otp_capture",
        title: "Enter the verification code",
        description: "We'll send a verification code to your mobile number",
        type: "otp",
      },
      {
        id: "user_type_selection",
        title: "Select your user type",
        description: "We'll send a verification code to your mobile number",
        type: "radio",
        options: [
          {
            id: "patient",
            title: "I am a Patient",
            description: "I am a Patient",
          },
          {
            id: "caregiver",
            title: "I am a Caregiver",
            description: "I am a Caregiver",
          },
        ],
      },
      {
        id: "patient_name_capture",
        title: "What is your name?",
        description: "Please enter the full name as per medical records",
        type: "text",
      },
      {
        id: "patient_gender_selection",
        title: "What is your gender?",
        description: "Please select your gender",
        type: "radio",
        options: genderOptions,
      },
      {
        id: "patient_dob_capture",
        title: "What is your date of birth?",
        description: "This helps us provide age-appropriate care",
        type: "date",
      },
      {
        id: "doctor_details_capture",
        title: "Please provide details of the patient's doctor",
        description:
          "We ask your doctor's details to ensure seamless coordination of your care",
        type: "automated_form", // ["automated_form", "manual_form"]
      },
      {
        id: "upload_documents",
        title: "Upload your documents",
        description: "Please upload the following documents",
        type: "document_upload",
        report_type: "acti_liv_program_report",
      },
    ],
  },
  app: {
    screens: {
      "home-screen": {
        id: "home-screen",
        title: "Home",
        description: "This is the home screen",
        type: "home",
        icon: "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/house.svg",
        activeIcon:
          "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/house.svg",
        components: [
          {
            id: "hero-section",
            type: "hero",
            title: "Welcome to Anaya Care",
            description: "Powered by Goodflip, your trusted health partner",
            background_image_url:
              "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-hero-background.png",
            logo_url:
              "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-logo.svg",
            show_header_items: true,
          },
          {
            id: "journey-card",
            type: "cycle",
            title: "Your Journey",
            description: "See how far you have come",
          },
          {
            id: "services-card",
            type: "card",
            title: "Services",
            description: "Quick access to care services",
            services: [
              {
                id: "book-appointments",
                title: "Book Appointments",
                description: "With our Nutritionists",
              },
              {
                id: "health-store",
                title: "Health Store",
                description: "Buy essentials health products",
              },
              {
                id: "book-lab-tests", // might be commented for first release
                title: "Book Lab Tests",
                description: "At discounted prices",
              },
              {
                id: "chat",
                title: "Chat with Specialists",
                description: "Get instant support and answers",
              },
            ],
          },
          {
            id: "reminders-card",
            type: "card",
            title: "Reminders",
            description: "Actions pending your attention",
          },
          {
            id: "today-progress-card",
            type: "card",
            title: "Today's Progress",
            description: "Track your daily wellness goals",
            options: [
              {
                id: "water-logs",
                color: "#3b82f6",
                title: "Water",
              },
              {
                id: "steps-logs",
                color: "#10b981",
                title: "Steps",
              },
              {
                id: "sleep-logs",
                color: "#8b5cf6",
                title: "Sleep",
              },
              {
                id: "diet-logs",
                color: "#3b82f6",
                title: "Diet",
              },
            ],
          },
          {
            id: "educational-content-card",
            type: "card",
            title: "Educational Content",
            description: "Personalized health tips for your health journey",
          },
          {
            id: "wallet-card",
            type: "card",
            title: "Wallet Balance",
            description: "Your wallet balance",
          },
          {
            id: "powered-by-logo",
          },
        ],
      },
      "records-screen": {
        id: "records-screen",
        title: "Records",
        description: "This is the records screen",
        type: "records",
      },
      // "program-screen": {
      //   id: "program-screen",
      //   title: "Program",
      //   description: "This is the program screen",
      //   type: "program",
      //   program_type: "treatment_journey",
      //   components: [
      //     {
      //       id: "hero-section",
      //       type: "hero",
      //       title: "Your Care Journey",
      //       description: "Comprehensive care with Anaya",
      //       background_image_url:
      //         "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-hero-background.png",
      //       logo_url:
      //         "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-logo.svg",
      //       show_header_items: false,
      //     },
      //     {
      //       id: "journey-card",
      //       type: "cycle",
      //       title: "Your Journey",
      //       description: "See how far you have come",
      //     },
      //     {
      //       id: "services-card",
      //       type: "card",
      //       title: "Services",
      //       description: "Quick access to care services",
      //       services: [
      //         {
      //           id: "book-appointments",
      //           title: "Book Appointments",
      //           description: "With our Nutritionists",
      //         },
      //         {
      //           id: "health-store",
      //           title: "Health Store",
      //           description: "Buy essentials health products",
      //         },
      //         {
      //           id: "book-lab-tests", // might be commented for first release
      //           title: "Book Lab Tests",
      //           description: "At discounted prices",
      //         },
      //         {
      //           id: "chat",
      //           title: "Chat with Specialists",
      //           description: "Get instant support and answers",
      //         },
      //       ],
      //     },
      //     // {
      //     //   id: "health-store-card",
      //     //   type: "card",
      //     //   title: "Health Store",
      //     //   description: "Everything you need for your health journey",
      //     //   view_all_link: "https://shop.goodflip.in/",
      //     //   options: [
      //     //     {
      //     //       id: "nutraceuticals",
      //     //       title: "Nutraceuticals",
      //     //       description: "This is the nutraceuticals card",
      //     //       link: "https://shop.goodflip.in/collections/supplements",
      //     //     },
      //     //   ],
      //     // },
      //     {
      //       id: "educational-content-card",
      //       type: "card",
      //       title: "Educational Content",
      //       description: "Personalized health tips for your health journey",
      //     },
      //     {
      //       id: "powered-by-logo",
      //     },
      //   ],
      // },
      "health-assistant-screen": {
        id: "health-assistant-screen",
        title: "Health Assistant Screen",
        description: "This is the chat screen",
        type: "health-assistant-screen",
      },
      "insights-screen": {
        id: "insights-screen",
        title: "Insights",
        description: "This is the insights screen",
        type: "insights",
        // tabs are present will code in page(web) - based on condition we will rendet the tabs. Ex: lab test is present then we will show the lab test tab.
        logs: [
          {
            id: "medication-logs",
            icon: "Medication",
            title: "Medication Logs",
            description: "Track your medication schedule and adherence",
          },
          {
            id: "water-logs",
            icon: "WaterFull",
            title: "Water Logs",
            description: "Track your daily water intake to stay hydrated",
          },
          {
            id: "sleep-logs",
            icon: "Bed",
            title: "Sleep Logs",
            description:
              "Track your sleep duration to improve rest and overall well-being",
          },
          {
            id: "steps-logs",
            icon: "DirectionsWalk",
            title: "Steps Logs",
            description: "Track your step count over time",
          },
          {
            id: "exercise-logs",
            icon: "Exercise",
            title: "Exercise Logs",
            description: "Track your workouts and physical activities",
          },
          // {
          //   id: "fatigue-logs",
          //   icon: "Fatigue",
          //   title: "Fatigue Logs",
          //   description:
          //     "Track your daily fatigue levels to identify patterns and triggers.",
          // },
          // {
          //   id: "menstruation-logs",
          //   icon: "Menstruation",
          //   title: "Menstruation Logs",
          //   description: "Track your menstrual cycle patterns and symptoms.",
          // },
          {
            id: "diet-logs",
            icon: "Restaurant",
            title: "Diet Logs",
            description: "Track your nutrition intake and dietary patterns",
          },
        ],
      },
      "chat-screen": {
        id: "chat-screen",
        title: "Chats",
        description: "This is the chat screen",
        type: "chat",
      },
    },
  },
} satisfies SupportProgramType;
